import {h, Fragment} from "preact"
import { AutocompleteElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo } from "preact/hooks"

import { productImagePlaceholder, getSrc, getSrcset, removePriceDecimal } from "../helpers"
import { currency } from "../config"

export default function DropdownProduct({ product }) {
    const { format } = useCurrencyFormatting();

    const tag = useMemo(() => {
        if (product.availability !== 'InStock') return 'Sold Out';
        if (product.inventoryLevel <= 5) return `${product.inventoryLevel} left`
        const customFlags = JSON.parse(product.customFields.find(f => f.key === 'custom-flag')?.value || '[]');
        if (customFlags.length > 0) return customFlags[customFlags.length - 1]
        return null;
    }, [])

    return (
        <AutocompleteElement 
            as="li" 
            hit={product} 
            class={`ns-autocomplete-product ${currency !== 'USD' ? 'ns-markets' : ''}`} //keep for currency loader (CSS)
            data-handle={product.url.split('/products/')[1]}
        >
            <div
                data-url={product.url}
                class="ns-flex ns-flex-col"
                data-nosto-element="product"
            >
                <div class="ns-product-media ns-block ns-w-100 ns-relative">
                    <a href={product.url} class="ns-product-link ns-block ns-w-100 ns-h-100">
                        <img
                            class="ns-absolute ns-block ns-w-100 ns-h-100"
                            src={getSrc(product.imageUrl, 832) ?? productImagePlaceholder}
                            srcset={getSrcset(product.imageUrl, [352, 832, 1200, 1920, 2000])}
                            alt={product.name}
                            width="2000"
                            height="3000"
                            loading="lazy"
                            sizes="(min-width:1600px) 2000px, (min-width: 750px) calc(100vw), calc(100vw)"
                        />
                    </a>
                </div>
                <div class="ns-product-info">
                    {tag &&
                        <p class="ns-product-tag">{tag}</p>
                    }
                    <a href={product.url} class="ns-product-link">
                        <h5 class="ns-product-title">
                            {product.name.split(' - ')[0]}
                        </h5>
                        <div class="ns-product-price-wrap">
                            <span class="ns-product-price" aria-label="Price">
                                {removePriceDecimal(format(product.price))}
                            </span>
                            {product?.listPrice && product.listPrice > product.price && (
                                <s class="ns-product-list-price" aria-label="Compare price">
                                    {removePriceDecimal(format(product.listPrice))}
                                </s>
                            )}
                        </div>
                    </a>
                </div>
            </div>
        </AutocompleteElement>
    )
}